import {Anchor, Text} from '@mantine/core';
import {Link} from 'react-router-dom';
import {AiOutlineLink} from 'react-icons/ai';

import {
    PlatformPropertyCard,
    PlatformPropertyCardProperty,
} from '@flexinet/ui-components';

import {Invoice} from '../types';
import {useAllowedItems} from '../../../hooks/useAllowedProperties.ts';
import {InvoiceStatusBadge} from './InvoiceStatusBadge.tsx';

export const InformationPropertyCard = ({record}: { record: Invoice }) => {

    const customerLabel = record.customer?.name ?? record.customerId;

    const properties = [
        {
            label: 'Invoice ID',
            value: record.id as string,
            span: 12,
        }, {
            label: 'Status',
            value: <InvoiceStatusBadge record={record}/>,
            span: 12,
        }, {
            label: 'Customer',
            value: record.customerId ? (
                <Link to={`/customers/${record.customerId}`} style={{textDecoration: 'none'}}>
                    <Text c='blue' style={{cursor: 'pointer'}}>{customerLabel}</Text>
                </Link>
            ) : 'n/a',
            span: 12,
        }, {
            label: 'Hosted Invoice',
            value: record.invoiceUrl ? (
                <Anchor
                    href={record.invoiceUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label={`View hosted invoice ${record.id}`}
                >
                    <AiOutlineLink size={14} style={{verticalAlign: 'middle', marginRight: 4}}/>
                    View hosted invoice
                </Anchor>
            ) : 'n/a',
            span: 12,
        }] as PlatformPropertyCardProperty[];

    const {filterAllowed} = useAllowedItems();
    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];

    return (<PlatformPropertyCard properties={allowedProperties}/>);
};
